import React, { useContext, useEffect, useState } from "react";
import * as XLSX from 'xlsx'
import styled from "@emotion/styled";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  MenuItem,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import NoData from "assets/noData.svg";
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "components/structure/Layout";
import DataTable from "utils/DataTable/DataTable";
import CloseIcon from "assets/closeIcon.svg";
import SeasonRegistrationService from "services/SeasonRegistrationService";
import CustomButton from "utils/CustomButton";
import { SnackbarContext } from "context/snackBarContext";
import { formatDate } from "utils/utils";
import { AuthData } from "auth/AuthWarpper";
import EditButton from "utils/EditButton";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "49.5rem",
  bgcolor: "background.paper",
  height: "18.125rem",
  borderRadius: "0.625rem",
};


let year = "";
let addClick = false;
const SeasonRegistration = () => {
  dayjs.extend(utc);
  const location = useLocation();
  const navigate = useNavigate();
  const yearSuccess = location.state?.year;
  const { user } = AuthData();
  const [data, setData] = useState([]);
  const [fetchError, setFetchError] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [cropYears, setCropYears] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchedYear, setFetchedYear] = useState("");
  const [isFetched, setIsFetched] = useState(false);
  const [yearReload, setYearReload] = useState(false);
  const [isSelectButton,setIsSelectButton] = useState(false)

  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);
  const moduleName = "Manage Operations";
  const functionalityName = "Season Registration";

  const read_only_user = user?.accessibleModules
    ?.find(module => module.module_name === moduleName)
    ?.accessible_functionalities
    ?.find(func => func.functionality_name === functionalityName)
    ?.read_only;

  const handleChange = (event) => {
    setFetchError(false);
    year = event.target.value;
    setYearReload(true);
    setIsSelectButton(true)
  };

  const columns = [
    {
      field: "country",
      headerName: "Country",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "cropYear",
      headerName: "Crop Year",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "seasonCode",
      headerName: "Season Code",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "seasonName",
      headerName: "Season Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "initialDateShow",
      headerName: "Start Date",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "endDateShow",
      headerName: "End Date",
      flex: 1,
      // width: 200,
  
      headerAlign: "center",
      align: "center",
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 250,
      headerAlign: "center",
      align: "center",
      getActions: (params) => {
        const state = {
          id: params.id,
          seasonCode: params.row.seasonCode,
          country: params.row.country,
          cropYear: params.row.cropYear,
          initialDate: params.row.initialDateShow,
          endDate: params.row.endDateShow,
          status: params.row.status,
          countryCode: params.row.countryCode,
          edit: true,
          isFetched: true,
          isSelectButton:isSelectButton,
          readOnly:read_only_user,
        };
        const url = `/editSeason`;
        return [<EditButton state={state} url={url} />];
      },
    },
  ];

  const fetchData = async () => {
    if (!year && !yearSuccess) return;
    // if (!user?.countryCode) return; // Check if user.countryCode is null or undefined
    setLoading(true);
    try {
      const response = await SeasonRegistrationService.getSeasonRegistration(
        year || yearSuccess
        // user.countryCode
      );

      const responseData = response.data.response;

      const rows = responseData.map((item) => ({
        id: item.cropSeasonUid,
        country: item.countryName,
        cropYear: item.cyCropYear,
        seasonCode: item.seasonCode,
        seasonName: item.seasonName,
        initialDate: formatDate(item.startDate),
        endDate: formatDate(item.endDate),
        initialDateShow:dayjs.utc(item?.startDate).format("DD/MM/YYYY"),
         endDateShow:dayjs.utc(item?.endDate).format("DD/MM/YYYY"),
        status: item.isActive === true ? "Active" : "InActive",
        countryCode: item.countryCode,
      }));
      setData(rows);
      setLoading(false);
      setFetchedYear(year || yearSuccess);
      setIsFetched(true);
      if (addClick === true) {
        navigate("/addSeason", {
          state: { cropYear: year || yearSuccess, isFetched: isFetched, readOnly:read_only_user},
        });
        addClick = false;
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        if (addClick === true) {
          handleOpen();
          addClick = false;
        }
        setFetchError(true);
      }
      console.error("Error fetching data:", error.message);
      setSeverity("error");
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
      setData([]);
    }
    setLoading(false);
  };

  const fetchDataAll = async (cropYearsFromApi) => {
    setLoading(true);
    // if (!year && !yearSuccess) return;
    console.log("fearch", cropYears);
    try {
      const response = await SeasonRegistrationService.getSeasonRegistrationAll(
        cropYearsFromApi
      );
      const responseData = response.data.response;

      const rows = responseData.map((item) => ({
        id: item.cropSeasonUid,
        country: item.countryName,
        cropYear: item.cyCropYear,
        seasonCode: item.seasonCode,
        seasonName: item.seasonName,
        initialDate: formatDate(item.startDate),
        endDate: formatDate(item.endDate),
        initialDateShow:dayjs.utc(item?.startDate).format("DD/MM/YYYY"),
         endDateShow:dayjs.utc(item?.endDate).format("DD/MM/YYYY"),

        status: item.isActive === true ? "Active" : "InActive",
        countryCode: item.countryCode,
      }));
      setData(rows);
      setLoading(false);
      setFetchedYear(year || yearSuccess);
      setIsFetched(true);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setSeverity("error");
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    SeasonRegistrationService.getCropYears()
      .then((response) => {
        // Extract crop years from response
        const cropYearsFromApi = response.data.response.map(
          (item) => item.cropYear
        );
        if(!yearSuccess) {
          fetchDataAll(cropYearsFromApi)
        }
        setCropYears(cropYearsFromApi);
      })
      .catch((error) => console.error("Error fetching data:", error));
    if (location?.state?.isFetched) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  // const yearSuccess = location.state?.year;
  //   if (cropYears.length > 0 && yearSuccess === "") {
  //     console.log("true")
  //     fetchDataAll();
  //   }
  // }, []);

  
 
 

  const handleAdd = () => {
    addClick = true;

    fetchData();
    // if (!fetchError) {
    //   return navigate("/addSeason" ,{state:{cropYear:year || yearSuccess,isFetched:isFetched}});
    // }
  };

  const handleYes = async () => {
    setLoading(true);
    try {
      const payload = {
        createdByUser: user.userName,
        modifiedByUser: user.userName,
        cyCropYear: year,
        countryCode: user?.countryCode,
      };

      const response = await SeasonRegistrationService.handleYesRegistration(
        fetchError,
        payload
      );

      const responseData = response.data.response;
      if (responseData) {
        SeasonRegistrationService.addCropStageCalendar(responseData).catch(
          (err) => console.log(err)
        );
      }
      //
      const rows = responseData.map((item) => ({
        id: item.cropSeasonUid,
        country: item.countryName,
        cropYear: item.cyCropYear,
        seasonCode: item.seasonCode,
        seasonName: item.seasonName,
        initialDate: formatDate(item.startDate),
        endDate: formatDate(item.endDate),
        initialDateShow:dayjs.utc(item?.startDate).format("DD/MM/YYYY"),
         endDateShow:dayjs.utc(item?.endDate).format("DD/MM/YYYY"),
        status: item.isActive === true ? "Active" : "InActive",
      }));
      setData(rows);
      setSeverity("success");
      setMessage("Added successfully");
      setOpenAlert(true);
      setLoading(false);
      handleClose();
    } catch (error) {
      console.error("Error fetching data:", error.response.data.message);
      setSeverity("error");
      setMessage(error?.response?.data?.message);
      setOpenAlert(true);
    }
    setLoading(false);
  };

  const handleNo = () => {
    return navigate("/addSeason", {
      state: { cropYear: year || yearSuccess, isFetched: isFetched,readOnly:read_only_user },
    });
  };

    const handleExportExcel = () => {
  if (data.length === 0) {
    setSeverity("warning");
    setMessage("No data available to export");
    setOpenAlert(true);
    return;
  }

  setLoading(true)

  try {
    const exportData = data.map(item => ({
      'Country': item.country,
      'Crop Year': item.cropYear,
      'Season Code': `\u200B${item.seasonCode}`,
      'Start Date': `\u200B${item.initialDateShow}`,
      'End Date': `\u200B${item.endDateShow}`,
      
    }));
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);
    XLSX.utils.book_append_sheet(wb, ws, "Season Registration");
    const filename = `Season Registration.csv`;
    // Write and download the file as CSV
    XLSX.writeFile(wb, filename, { bookType: 'csv' });

  } catch (error) {
    console.error("Error exporting to Excel:", error);
    setSeverity("error");
    setMessage("Failed to export Excel file");
    setOpenAlert(true);
  }
  finally{
    setLoading(false)
  }
};

  return (
    <Layout title="Season Registration List">
      <div
        style={{
          fontWeight: 600,
          fontSize: "1.25rem",
          color: "rgba(115, 125, 134, 1)",
          marginBottom: "1rem",
          paddingLeft: "0.5rem",
        }}
      >
        Season Registration List
      </div>
      <RegistrationOptions>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FormControl
            sx={{ m: 1, minWidth: { xs: 150, md: 300 }, minHeight: 50 }}
          >
            <TextField
              select
              value={year || yearSuccess}
              onChange={handleChange}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              label={year ? "" : "Crop Year"}
            >
              {/* <MenuItem onClick={fetchDataAll(cropYears)} value="">
                <em>Crop Year</em>
              </MenuItem> */}
              {cropYears.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
          <Button
            sx={{
              borderRadius: 10,
              minWidth: 95,
              minHeight: 44,
              background: "#102A62",
              marginTop: { xs: 1 },
              marginLeft: { xs: 1 },
            }}
            startIcon={loading && <CircularProgress size={20} />}
            variant="contained"
            onClick={fetchData}
            disabled={loading}
          >
            Get
          </Button>
        </div>
        <div>
          {(year || yearSuccess || yearReload) && (
            <Button
              sx={{
                borderRadius: 100,
                minWidth: 95,
                minHeight: 44,
                background: "#102A62",
                marginTop: { xs: 1 },
                marginLeft: { xs: 1 },
                '&.Mui-disabled': {
                        backgroundColor: "#102A62", 
                        color: "#ffffff",    
                        opacity: 0.6,          
                        },
              }}
              variant="contained"
              startIcon={<AddCircleIcon />}
              onClick={handleAdd}
              disabled={loading || read_only_user}
            >
              {loading && <CircularProgress size={20} />}
              Add
            </Button>
          )}
          <Button
            sx={{
              borderRadius: "10px",
              minWidth: 182,
              minHeight: 40,
              background: "#0F2B63", 
              marginTop: "8px",
              marginLeft: "20px",
              float:"right",
              "&:hover": {
                backgroundColor: "#0F2B63",
              },
              '&.Mui-disabled': {
                        backgroundColor: "#102A62", 
                        color: "#ffffff",    
                        opacity: 0.6,          
                        },
              padding:'8px 14px',
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", 
              fontFamily:"Montserrat",
              fontWeight:"600",
              fontSize:"16px",
    
            }}
            variant="contained"
            onClick={handleExportExcel}
            disabled={loading || data.length === 0}
          >
            {loading && <CircularProgress size={20} />}
            EXPORT TO EXCEL
          </Button>
        </div>
      </RegistrationOptions>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              background: " #F2BB40",
              borderTopLeftRadius: "0.625rem",
              borderTopRightRadius: "0.625rem",
              p: 4,
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                sx={{ fontWeight: 600, fontSize: "1.25rem", color: "#191E31" }}
              >
                Add
              </Typography>
              <img
                style={{ cursor: "pointer" }}
                onClick={handleClose}
                src={CloseIcon}
                alt="Close Icon"
              />
            </Box>
          </Box>
          <Box sx={{ p: 4 }}>
            <Typography sx={{ fontWeight: 500, fontSize: "1.125rem" }}>
              You are creating a new crop season{" "}
              <span style={{ fontWeight: 700 }}>({year})</span> , do you want to
              use the same setup
              <span style={{ fontWeight: 700 }}> {"( Crop Stage Calendar, Module, Sub Module)"}
              </span> 
              {/* You  will be able to edit it later if desired. */}
            </Typography>
            <Box
              sx={{
                mt: 4,
                justifyContent: "flex-end",
                display: "flex",
                gap: "1rem",
              }}
            >
              <CustomButton variant="cancel" onClick={handleNo} label="No" />

              <CustomButton onClick={handleYes} label="Yes" loading={loading} />
            </Box>
          </Box>
        </Box>
      </Modal>

      {loading ? (
        ""
      ) : (
        <DataContainer>
          {data.length !== 0 ? (
            <DataTable
              data={data}
              rows={data}
              columns={columns}
              hideFooter={true}
            />
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src={NoData} style={{ height: "100px" }} alt="No Data" />
              <p>No Data Available</p>
            </Box>
          )}
        </DataContainer>
      )}
    </Layout>
  );
};

const RegistrationOptions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

const DataContainer = styled.div`
  margin-top: 2rem;
`;

export default SeasonRegistration;
